<div class="card">
    <p-tabs value="0" (valueChange)="selectTab($event)">
        <p-tablist>
            <p-tab value="0">Overview</p-tab>
            <p-tab value="1">Attendance</p-tab>
            <p-tab value="2">Exams</p-tab>
            <p-tab value="3">Time Table</p-tab>
            <p-tab value="4">Fees</p-tab>
            <p-tab value="5">Library Details</p-tab>
            <p-tab value="6">Documents</p-tab>
            <p-tab value="7">Hostel</p-tab>
            <p-tab value="8">Transport</p-tab>
        </p-tablist>

        <p-tabpanels  style="height: 78vh; overflow-y: auto;">

            <!-- ✅ Overview -->
            <p-tabpanel value="0" class="p-4 overflow-y-auto"
            >
                <app-student-overview [studentDetails]="studentDetails" [allCourses]="allCourses"
                    [academicYearList]="academicYearList" [departmentList]="departmentList" [batchList]="batchList"
                    [feeCategoryList]="feeCategoryList" [hostelCategoryList]="hostelCategoryList"
                    [transportRouteList]="transportRouteList" [scholarshipTypeList]="scholarshipTypeList"
                    [allLeadFeilds]="allLeadFeilds" [fieldValues]="fieldValues"
                    (onUpdate)="handleUpdate($event)">
                </app-student-overview>
            </p-tabpanel>

            <!-- ✅ Attendance -->
            <p-tabpanel value="1" class="p-4 text-center text-gray-500">
                <!-- <app-student-attendance [studentId]="studentDetails.student_id"></app-student-attendance> -->
                 <p>📚 Please Contact Admin to Configure this module</p>
            </p-tabpanel>

            <!-- 🕒 Coming Soon Tabs -->
            <p-tabpanel value="2" class="p-4 text-center text-gray-500">
                <p>📘 Please Contact Admin to Configure this module</p>
            </p-tabpanel>

            <p-tabpanel value="3" class="p-4 text-center text-gray-500">
                <p>🕒 Please Contact Admin to Configure this module</p>
            </p-tabpanel>

            <!-- ✅ Fees -->
            <p-tabpanel value="4" class="p-4 text-center text-gray-500">
                <!-- <app-student-fees [studentDetails]="studentDetails"></app-student-fees> -->
                <p>💰 Please Contact Admin to Configure this module</p>
            </p-tabpanel>

            <!-- 🕒 Coming Soon -->
            <p-tabpanel value="5" class="p-4 text-center text-gray-500">
                <p>📚 Please Contact Admin to Configure this module</p>
            </p-tabpanel>

            <p-tabpanel value="6" class="p-4 text-center text-gray-500">
                <p>📄 Please Contact Admin to Configure this module</p>
            </p-tabpanel>

            <!-- ✅ Hostel -->
            <p-tabpanel value="7" class="p-4 text-center text-gray-500">
                <!-- <app-student-hostel [studentDetails]="studentDetails"></app-student-hostel> -->
                <p>🏨 Please Contact Admin to Configure this module</p>
            </p-tabpanel>

            <!-- ✅ Transport -->
            <p-tabpanel value="8" class="p-4 text-center text-gray-500">
                <!-- <app-student-transport [studentDetails]="studentDetails"></app-student-transport> -->
                <p>🚌 Please Contact Admin to Configure this module</p>
            </p-tabpanel>

        </p-tabpanels>
    </p-tabs>
</div>